import { isString } from "./is.mjs";
import { isDefined, isUndefined, notUndefined } from "./guards.mjs";
import { REGEXP_EXTENDED_ASCII, REGEXP_LATIN_WORD, REGEXP_WORD } from "./regex.mjs";
import { nilDefault } from "./function.mjs";
import { get } from "./object.mjs";
export const toString = (str, defaultValue = "") => {
  if (isUndefined(str))
    return defaultValue;
  if (isString(str))
    return str;
  return String(str);
};
export const toWords = (string, pattern) => {
  const subjectString = toString(string);
  const patternRegExp = isDefined(pattern) ? pattern : REGEXP_EXTENDED_ASCII.test(subjectString) ? REGEXP_LATIN_WORD : REGEXP_WORD;
  return nilDefault(subjectString.match(patternRegExp), []);
};
export const toLowerCase = (string) => {
  return toString(string).toLowerCase();
};
export const toUpperCase = (string) => {
  return toString(string).toUpperCase();
};
export const toKebabCase = (string) => {
  return toWords(string).map(toLowerCase).join("-");
};
export const toSnakeCase = (string) => {
  return toWords(string).map(toLowerCase).join("_");
};
export const toCapitalize = (string) => {
  const subjectString = toLowerCase(string);
  return toUpperCase(subjectString[0]) + subjectString.substr(1);
};
export const toCamelCase = (string) => {
  const wordToCamel = (string2, index) => {
    return index === 0 ? toLowerCase(string2) : toCapitalize(string2);
  };
  return toWords(string).map(wordToCamel).join("");
};
export const removeVietnameseTones = (str) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "");
  str = str.replace(/\u02C6|\u0306|\u031B/g, "");
  str = str.replace(/ + /g, " ");
  str = str.trim();
  str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
  return str;
};
export const template = (string, data, config = { delimiters: ["{{", "}}"] }) => {
  const [startDelimiter, endDelimiter] = config.delimiters;
  const placeholderRegex = new RegExp(`${startDelimiter}(.*?)${endDelimiter}`, "g");
  return string.replace(placeholderRegex, (match, key) => {
    const value = get(data, key.trim());
    return notUndefined(value) ? value : match;
  });
};
